import { useState } from 'react';
import useFetchIam from '@/features/agent/api/useFetchIam';
import TutorialStep1 from '../components/TutorialStep1';
import TutorialStep2 from '../components/TutorialStep2';
import TutorialStep3 from '../components/TutorialStep3';

export default function TrialTutorialTemplate() {
  const { data: iam } = useFetchIam();
  const [currentStep, setCurrentStep] = useState(1);

  // トライアル版でない場合は/agentにリダイレクト
  const isTrial = iam?.plan_type === 'trial';
  if (iam && !isTrial) {
    window.location.href = '/agent';
    return null;
  }

  const handleNext = () => {
    if (currentStep < 3) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleBack = () => {
    if (currentStep > 1) {
      setCurrentStep(currentStep - 1);
    }
  };

  return (
    <div className="relative z-10 mx-auto flex size-full min-h-screen max-w-[1044px] flex-col items-center justify-center px-md">
      {/* タイトルセクション */}
      <div className="mb-xl text-center">
        <h1 className="text-3xl font-bold text-black">
          アカウントを連携することで、求人を一括管理できます。
        </h1>
      </div>

      {/* 説明文 */}
      <div className="mb-xl flex w-full justify-center">
        <p className="text-center text-body-md text-black/70">
          他サービスに掲載された求人をもとに、求人票を作成・管理ができます。
        </p>
      </div>

      {/* メインカード */}
      <div className="w-full rounded border border-white bg-white px-0 py-8 shadow-layer2">
        {currentStep === 1 && <TutorialStep1 onNext={handleNext} />}
        {currentStep === 2 && <TutorialStep2 onNext={handleNext} onBack={handleBack} />}
        {currentStep === 3 && <TutorialStep3 onBack={handleBack} />}
      </div>
    </div>
  );
}
